import { useSession } from '@/features/auth/useSession';

/**
 * S2B-01 — surfaces this seat may reach.
 *
 * A permission is a standing grant the SPA can read. Delegated authority is a
 * row with a window and a status, held by somebody who deliberately does NOT
 * hold the standing permission — so the client cannot compute it, and the
 * navigation that tried to gated the approvals entry on the permission instead.
 * The delegate got real work and no door to it.
 *
 * The server decides, in one place, and the inbox endpoint gates on the same
 * call. Defaults to closed while the session loads: a menu item that appears
 * and vanishes is worse than one that arrives a moment late.
 */
export type ReachableSurface = 'approvals';

export function useEffectiveAuthority(): (surface: ReachableSurface) => boolean {
  const { session } = useSession();

  return (surface) => session?.effective_authority?.[surface] ?? false;
}
